import { useState } from 'react';
import { useLang, AVAILABLE_LANGS } from '@/lib/translations';
import { Globe } from 'lucide-react';

export default function LanguageSwitcher({ className = '' }) {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);

  return (
    <div className={`relative ${className}`} data-testid="language-switcher">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 px-2.5 py-1.5 border border-white/10 hover:border-aurocle-gold/30 transition-all text-xs font-mono uppercase tracking-wider text-aurocle-text-secondary hover:text-aurocle-gold"
        data-testid="lang-toggle"
      >
        <Globe size={12} />
        {lang.toUpperCase()}
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute top-full right-0 mt-2 z-50 bg-aurocle-elevated border border-aurocle-gold/15 shadow-xl min-w-[140px]" data-testid="lang-dropdown">
            {AVAILABLE_LANGS.map((l) => (
              <button
                key={l.code}
                onClick={() => { setLang(l.code); setOpen(false); }}
                className={`w-full flex items-center gap-3 px-4 py-2.5 text-xs transition-all ${
                  lang === l.code
                    ? 'bg-aurocle-gold/10 text-aurocle-gold'
                    : 'text-aurocle-text-secondary hover:bg-white/3 hover:text-aurocle-text'
                }`}
                data-testid={`lang-option-${l.code}`}
              >
                <span className="font-mono w-5">{l.label}</span>
                <span>{l.full}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
